import {Component, Input} from "@angular/core";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {EditService} from "../../../framework/entity/edit/edit-page/edit.service";

@Component({
    selector: "wbo-date-range-report-criteria",
    templateUrl: "./date-range-report-criteria.component.html"
})
export class DateRangeReportCriteriaComponent {

    @Input() fromDateField: string = "startDate";
    @Input() toDateField: string = "finishDate";
    @Input() fromTimeField: string = "startTime";
    @Input() toTimeField: string = "finishTime";
    @Input() dateRangePeriodField: string = "dateRangePeriod";
    @Input() disabled: boolean = false;

    constructor(public model: ReportModel<any>, public editService: EditService) {
    }

    get isDateControlsReadOnly(): boolean {
        return this.model.data[this.dateRangePeriodField] !== "CUSTOM" || this.disabled;
    }
}
